import { render, staticRenderFns } from "./EditProperty.vue?vue&type=template&id=34da0a9b&"
import script from "./EditProperty.vue?vue&type=script&lang=js&"
export * from "./EditProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports